export const DefaultUserIcon = ({ classes }) => (
  <svg className={classes} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx={18} cy={18} r="17.5" fill="#F9F9F9" stroke="#DADADA" />
    <path
      d="M24.4749 24.5C24.2189 21.145 21.4209 18.5 17.9999 18.5C14.5789 18.5 11.7809 21.145 11.5249 24.5"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18.5C19.933 18.5 21.5 16.933 21.5 15C21.5 13.067 19.933 11.5 18 11.5C16.067 11.5 14.5 13.067 14.5 15C14.5 16.933 16.067 18.5 18 18.5Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
